module.exports = __webpack_public_path__ + "static/media/search-field-icon.93ffaedb.svg";